module.exports = __webpack_public_path__ + "static/media/Hogskolanpaaland-alt.61acd8b0.webp";